import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Play",
  "use": "icon-Play-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-Play\"><path d=\"M19.117 11.013L8.165 4.607A.774.774 0 007 5.273v13.454c0 .61.678.98 1.193.648l10.952-7.046a.771.771 0 00-.027-1.316z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol